document.addEventListener('DOMContentLoaded', () => {
	if (document.querySelector('.oa-hero')) {
		const heroSwiper = new Swiper('.oa-hero .swiper', {
			slidesPerView: 1,
			grabCursor: true,
			speed: 1000,
			loop: true,
			effect: 'fade',
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			},
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true
			}
		});
	}
});
